export const FALLBACK_INQUIRY_EMAIL = "request@companycue.com";

export const STATUS_COLORS = [
  {
    statuses: ["Assigned"],
    value: "#EAD1DC",
  },
  {
    statuses: ["Delivered", "Canceled (Billed)", "Resolved"],
    value: "#B6D7A8",
  },
  {
    statuses: ["Pending Hours"],
    value: "#F1DE99",
  },
  {
    statuses: ["Pending Review", "Reviewing Hours"],
    value: "#EFCD56",
  },
  {
    statuses: ["Secondary Complete"],
    value: "#C9DAF8",
  },
  {
    statuses: ["Primary Complete"],
    value: "#D9D2E9",
  },
  {
    statuses: ["QC Complete"],
    value: "#FFFF8D",
  },
  {
    statuses: ["Confirmed", "Reported by Staff", "Reported by PM", "Requested"],
    value: "#f2e8f3",
  },
  {
    statuses: ["Design in Progress"],
    value: "#fff",
  },
  {
    statuses: ["Rejected", "Client Reviewed"],
    value: "#6FA8DC",
  },
  {
    statuses: ["Archived"],
    value: "#d3d3d3",
  },
  {
    statuses: ["Ready for Delivery"],
    value: "#FFD180",
  },
  {
    statuses: ["On Hold", "Reported to Client", "Quantity Needed"],
    value: "#78909C",
  },
  {
    statuses: ["Canceled", "Canceled (Not Billed)"],
    value: "#ffbaba",
  },
];

export const DOMAIN =
  process.env.VUE_APP_NODE_ENV === "production"
    ? "https://cocuehub.com"
    : process.env.VUE_APP_NODE_ENV === "staging"
    ? "https://cocuedev.com"
    : process.env.VUE_APP_NODE_ENV === "production-quickbase"
    ? "https://cocueadmin.com"
    : process.env.VUE_APP_NODE_ENV === "staging-quickbase"
    ? "https://cue-workbench-staging.netlify.app"
    : "http://localhost:8080";

export const ROUTES = {
  dataUpload: "data-upload",
  spreadsheetUpload: "spreadsheet-upload",
  spreadsheetUploadV2: "spreadsheet-upload-v2",
  fileSplitter: "file-splitter",
  invoiceBot: "invoice-bot",
  calendar: "calendar",
  clientEmails: "client-emails",
  myCue: "mycue",
  pmDashboard: "pm-dashboard",
  assignmentDashboard: "assignment-dashboard",
  assignmentDashboardV2: "assignment-dashboard-v2",
  issueTracker: "issue-tracker",
  editor: "editor",
  request: "request",
  typeforms: "typeforms",
  paymentRequests: "payment-requests",
  ledDashboard: "led-dashboard",
  workflows: "workflows",
  staff: "staff",
  cueHardware: "cue-hardware",
  cueSoftware: "cue-software",
  clients: "clients",
  clientRequesters: "client-requesters",
  purchaseOrders: "purchase-orders",
  customerPriceList: "customer-price-list",
  projects: "projects",
  requestedAssignments: "requested-assignments",
  settings: "settings",
  paymentRequestForms: "payment-request-forms",
  vendorRequestForms: "vendor-request-forms",
  requestanAssignment: "request-an-assignment",
};

export const ISO_COUNTRIES = {
  Afghanistan: "AF",
  "Aland Islands": "AX",
  Albania: "AL",
  Algeria: "DZ",
  "American Samoa": "AS",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antarctica: "AQ",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bermuda: "BM",
  Bhutan: "BT",
  Bolivia: "BO",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  "Bouvet Island": "BV",
  Brazil: "BR",
  // "British Indian Ocean Territory": "IO",
  "Brunei Darussalam": "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  "Cabo Verde": "CV",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  "Cayman Islands": "KY",
  "Central African Republic": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  "Christmas Island": "CX",
  "Cocos (Keeling) Islands": "CC",
  Colombia: "CO",
  Comoros: "KM",
  "Congo (Congo-Brazzaville)": "CG",
  "Cook Islands": "CK",
  "Costa Rica": "CR",
  "Côte d'Ivoire": "CI",
  Croatia: "HR",
  Cuba: "CU",
  Cyprus: "CY",
  "Czech Republic": "CZ",
  "Democratic Republic of the Congo": "CD",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  Ecuador: "EC",
  Egypt: "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Eswatini: "SZ",
  Ethiopia: "ET",
  "Falkland Islands (Malvinas)": "FK",
  "Faroe Islands": "FO",
  Fiji: "FJ",
  Finland: "FI",
  France: "FR",
  "French Guiana": "GF",
  "French Polynesia": "PF",
  "French Southern Territories": "TF",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Greece: "GR",
  Greenland: "GL",
  Grenada: "GD",
  Guadeloupe: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernsey: "GG",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haiti: "HT",
  "Heard Island & Mcdonald Islands": "HM",
  "Holy See (Vatican City State)": "VA",
  Honduras: "HN",
  "Hong Kong": "HK",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  "Iran, Islamic Republic Of": "IR",
  Iraq: "IQ",
  Ireland: "IE",
  "Isle Of Man": "IM",
  Israel: "IL",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jersey: "JE",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  "Libyan Arab Jamahiriya": "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Macao: "MO",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  "Marshall Islands": "MH",
  Martinique: "MQ",
  Mauritania: "MR",
  Mauritius: "MU",
  Mayotte: "YT",
  Mexico: "MX",
  "Micronesia, Federated States Of": "FM",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "Netherlands Antilles": "AN",
  "New Caledonia": "NC",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  "Norfolk Island": "NF",
  "North Korea": "KP",
  "North Macedonia": "MK",
  "Northern Ireland": "GB",
  "Northern Mariana Islands": "MP",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  "Palestine State": "PS",
  Panama: "PA",
  "Papua New Guinea": "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippines: "PH",
  Pitcairn: "PN",
  Poland: "PL",
  Portugal: "PT",
  "Puerto Rico": "PR",
  Qatar: "QA",
  Reunion: "RE",
  Romania: "RO",
  "Russian Federation": "RU",
  Rwanda: "RW",
  "Saint Barthelemy": "BL",
  "Saint Helena": "SH",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Martin": "MF",
  "Saint Pierre and Miquelon": "PM",
  "Saint Vincent and the Grenadines": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Georgia and Sandwich Isl.": "GS",
  "South Korea": "KR",
  "South Sudan": "SS",
  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  "Svalbard and Jan Mayen": "SJ",
  Sweden: "SE",
  Switzerland: "CH",
  "Syrian Arab Republic": "SY",
  Taiwan: "TW",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  "Timor-Leste": "TL",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  "Trinidad and Tobago": "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  "Turks and Caicos Islands": "TC",
  Tuvalu: "TV",
  Uganda: "UG",
  Ukraine: "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United States of America": "US",
  "United States Outlying Islands": "UM",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  Venezuela: "VE",
  Vietnam: "VN",
  "Virgin Islands, British": "VG",
  "Virgin Islands, U.S.": "VI",
  "Wallis and Futuna": "WF",
  "Western Sahara": "EH",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",
};

export const alphabetColors = [
  { character: "A", color: "#FF5733" },
  { character: "B", color: "#33FF57" },
  { character: "C", color: "#3357FF" },
  { character: "D", color: "#FF33A8" },
  { character: "E", color: "#FF8C33" },
  { character: "F", color: "#33FFF0" },
  { character: "G", color: "#C833FF" },
  { character: "H", color: "#FF3333" },
  { character: "I", color: "#33FF8C" },
  { character: "J", color: "#5733FF" },
  { character: "K", color: "#FF33FF" },
  { character: "L", color: "#FFAF33" },
  { character: "M", color: "#33FFAF" },
  { character: "N", color: "#AF33FF" },
  { character: "O", color: "#FF5733" },
  { character: "P", color: "#FF3357" },
  { character: "Q", color: "#33FFAF" },
  { character: "R", color: "#FF8C33" },
  { character: "S", color: "#FF33AF" },
  { character: "T", color: "#33AFFF" },
  { character: "U", color: "#33FF33" },
  { character: "V", color: "#FF33FF" },
  { character: "W", color: "#FF5733" },
  { character: "X", color: "#33FF57" },
  { character: "Y", color: "#3357FF" },
  { character: "Z", color: "#FF33A8" }
];

export const managersDesiredColors = [
  { name: "Karen Estrada", color: "#EC407A" },
  { name: "Sara Marcial", color: "#AB47BC" },
  { name: "Lucia Cantone", color: "#7E57C2" },
  { name: "Silvana Porcu", color: "#26C6DA" },
  { name: "Anita Xu", color: "#66BB6A" },
  { name: "Ciwar El-Tayeh", color: "#FFEE58" },
  { name: "Natalya Corbin", color: "#FFCA28" },
];

export const fileLocationDropdownOptions = [
  { label: "Baseline", link: "https://baseline.apple.com/" },
  { label: "Dropbox", link: "https://www.dropbox.com/" },
  { label: "DubEditor", link: "https://cocuehub.com/editor" },
  { label: "iCloud", link: "https://www.icloud.com/" },
  { label: "Shakespeare", link: "https://wrkflow.app/" },
  { label: "SmartCat", link: "https://www.smartcat.com/" },
  { label: "Smartling", link: "https://www.smartling.com/" },
  { label: "TryRating", link: "https://www.tryrating.com/" },
  { label: "Other", link: "https://cocuehub.com/" },
];

export const userRolesList = [
  "PRIMARY",
  "SECONDARY",
  "QC"
];